import { render, staticRenderFns } from "./OrdersSelect.vue?vue&type=template&id=97c5623a&"
import script from "./OrdersSelect.vue?vue&type=script&lang=js&"
export * from "./OrdersSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports